<div class="row">
  <div class="col">
    <p class="text-primary mt-2">
      Almost done! We just need a few more details.
    </p>
    <h2>Finish &amp; Submit</h2>
  </div>
</div>

<form [formGroup]="employerFormGroup">
  <ng-container *ngIf="!unemployed">
    <app-employer-info [controls]="employerFormGroup.controls"></app-employer-info>

    <app-contact-info [controls]="employerFormGroup.controls"></app-contact-info>
  </ng-container>

  <app-employer-payment-info [controls]="employerFormGroup.controls"
    (changeEvent)="onPayTypeChange($event)"></app-employer-payment-info>

  <app-other-incomes-info [controls]="employerFormGroup.controls" [isConsumerLoanApplication]="false"
    (clearEvent)="onClearOtherIncomesClick()" (changeEvent)="onOtherIncomeChange($event)"></app-other-incomes-info>

  <hr class="hr-style" />

  <h2>Personal Identification Information</h2>

  <div class="row">
    <div class="col-12 col-md-10 col-lg-6 col-xl-5">
      <app-secure-info [controls]="employerFormGroup.controls"></app-secure-info>
    </div>
  </div>

  <hr class="hr-style" />

  <app-electronic-signature-info [controls]="employerFormGroup.controls"
    [isConsumerLoanApplication]="false"></app-electronic-signature-info>
</form>

<div class="row my-5">
  <div class="col-12 col-md-6">
    <button [disabled]="isSaving" type="button" class="btn btn-primary" (click)="onNext()">
      <span *ngIf="isSaving" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
      <span>Submit Application</span>
    </button>

    <app-validation-text [show]="isDirtyAndMissingRequiredFields"></app-validation-text>
  </div>
  <div class="col-12 col-md-6">
    <div class="mt-3 mt-sm-0 text-center text-md-end">
      <button [disabled]="isSaving" class="btn btn-link" (click)="onExitApplication()">
        <small> Clear Application </small>
      </button>
    </div>
  </div>
</div>